// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-window{
  height: 500px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlbGZ5LXNpbXBsZS1wcm9qZWN0LXJlc3VsdC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBYTtBQUNmIiwiZmlsZSI6IndlbGZ5LXNpbXBsZS1wcm9qZWN0LXJlc3VsdC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnNtYWxsLXdpbmRvd3tcbiAgaGVpZ2h0OiA1MDBweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/core/components/welfy-simple-project-result/welfy-simple-project-result.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,gWAAgW","sourcesContent":[".small-window{\n  height: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
